const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MEDIA)

export const apiMedia = {
	storeMedia: async (files: IFile[], modelID: string | number, collection: EMediaCollection) => {
		const formData = new FormData()
		files.forEach((file, index) => {
			if (!file.media) throw new Error(`File at index ${index} is missing`)
			if (typeof file.order !== 'number') throw new Error(`Order at index ${index} is invalid`)

			formData.append(`media[${index}][file]`, file.media)
			formData.append(`media[${index}][order]`, (file.order + 1).toString())
		})

		formData.append('collection_name', collection as string)
		formData.append('entity_id', modelID as string)
		const { data } = await apiCommon<IMedia[]>(
			`${groupPrefix}`,
			{
				method: 'POST',
				body: formData,
			},
			'pl',
			true,
		)
		return { data: data.map(m => Media(m)) }
	},

	fetchMedia: async (collectionName?: EMediaCollection) => {
		let url = `${groupPrefix}`
		const queryParams = []
		if (collectionName) {
			queryParams.push(`filter[collection_name]=${collectionName}`)
		}
		if (queryParams.length) {
			url += `?${queryParams.join('&')}`
		}
		const { data } = await apiCommon<IMedia[]>(url, {
			method: 'GET',
		})
		return { data: data.map(m => Media(m)) }
	},

	destroyMedia: async (mediaUUids: string[]) =>
		await apiCommon<IMedia[]>(`${groupPrefix}`, {
			method: 'DELETE',
			body: { media: mediaUUids },
		}),

	reorderMedia: async (mediaUUids: string[]) =>
		await apiCommon(`${groupPrefix}/order`, {
			method: 'PUT',
			body: { order: mediaUUids },
		}),
}
